import React, { useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const {
    isLoading,
    isAuthenticated,
    activeNavigator,
    error,
    signinRedirect,
  } = useAuth();

  const location = useLocation();
  const hasTriggeredLogin = useRef(false);

  useEffect(() => {
    // already tried login once → do nothing
    if (hasTriggeredLogin.current) return;

    // don’t redirect while loading, already authenticated,
    // in the middle of a navigation, in /auth/, or if we have an error
    if (
      isLoading ||
      isAuthenticated ||
      activeNavigator ||
      error ||
      location.pathname.startsWith("/auth/")
    ) {
      return;
    }

    // mark that we've fired the login once
    hasTriggeredLogin.current = true;

    const dest = location.pathname + location.search || "/reporttool";
    sessionStorage.setItem("post_login_path", dest);

    signinRedirect?.({ redirectMethod: "replace" });
  }, [
    isLoading,
    isAuthenticated,
    activeNavigator,
    error,
    location.pathname,
    location.search,
    signinRedirect,
  ]);

  // While loading or redirect in progress: render nothing
  if (isLoading || (!isAuthenticated && !error && hasTriggeredLogin.current)) {
    return null;
  }

  // If OIDC is misconfigured in dev, show the error instead of looping forever
  if (error) {
    return (
      <div role="alert" style={{ padding: 24 }}>
        Auth error: {String(error.message || error)}
      </div>
    );
  }

  if (!isAuthenticated) {
    // redirect already triggered / will be triggered; no UI
    return null;
  }

  return children;
}
